module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_sns_04-86110c8eeaadbc1be68b351ed0862bc2.jpg";